export function generateInvoiceNumber(num){
    return ""+(new Date().getTime())
}